import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE } from "../../../routes";
import { ShuttleBusBookingSetMaximumHeader } from "./add_header";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

import { ShuttleBusBookingSetMaximumSteps } from "./add_steps";
import { TextBox } from "@progress/kendo-react-inputs";
import { createAndUpdateSetMaximum, fetchSetMaximumDetail } from "../../../store/shuttle_bus_booking/set_maximum";

export const ShuttleBusBookingSetMaximumUpdate = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);

  const [errors, setErrors] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selected_tab, setSelectedTab] = useState(
    parseInt(query.get("state", 0)) || 0
  );
  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const updatePermssion = checkPermission(
    userPermissions,
    "bus_booking.update_maximum_config"
  );

  const [editData, setEditData] = useState({
    max_order_time: 0,
    max_available_seat: 0,
    max_geofence_area: "",
  });



  const { detail_data, detail_loading } = useSelector(
    (state) => state.shuttleBusSetMaximum
  );

  const getData = async () => {
    dispatch(fetchSetMaximumDetail(id));
  };


  useEffect(() => {
    getData();
  }, [id]);

  useEffect(() => {

    setEditData({
      max_order_time: detail_data.max_order_time,
      max_available_seat: detail_data.max_available_seat,
      max_geofence_area: detail_data.max_geofence_area,
    });

  }, [detail_data]);



  const handleSubmit = () => {
    setLoading(true);

    dispatch(createAndUpdateSetMaximum({ data: editData, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {

        setLoading(false);
        navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST);

      } else {
        setLoading(false);


      }
    });


  };


  const checkMandatoryFields = () => {

    const { max_order_time, max_available_seat, max_geofence_area } = editData;

    if (!max_order_time || !max_available_seat || !max_geofence_area) {
      console.error("All fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }

    setShowRequiredFieldError(false);

    return false;
  }


  const handleNext = () => {

    if (checkMandatoryFields()) return;


    let tab = parseInt(selected_tab) + 1;

    setSelectedTab(tab);
    setId(id);
    query.set("state", tab);
    navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE + "?" + query.toString());
  };

  const callback_handleBackBtn = (e) => {

    if (parseInt(selected_tab) === 0) {
      navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST);
      return;
    }

    let currentTab = selected_tab > 0 ? (selected_tab - 1) : 0;

    if (id) {
      query.set("id", id);
    }
    query.set("state", currentTab);

    setSelectedTab(currentTab);
    navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE + "?" + query.toString());
  };

  const getSortIcon = () => {
    return (<svg width="10" height="14" viewBox="0 0 10 14">
      <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
      <path d="M0 8 L5 13 L10 8 Z" fill="#999" />
    </svg>);
  };



  return (
    <>
      {(id && updatePermssion) ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}



          {(detail_loading || loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <ShuttleBusBookingSetMaximumHeader
            backBtncallback={(e) => callback_handleBackBtn(e)}
            state={selected_tab}
          />
          <ShuttleBusBookingSetMaximumSteps
            state={selected_tab}
            setState={setSelectedTab}
            checkMandatoryFields={checkMandatoryFields}
            handleSubmit={handleSubmit}
            editData={editData}
          />

          <div className="main-shuttle-bus-container-with-header">
            <div className="main-poll-survey">
              {selected_tab == 0 && (
                <div className="shuttle_bus_booking_create_item_main_box_detail">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Max geofence area  & available seat
                  </div>
                  <div style={{ marginTop: "10px", border: "1px solid #eee", borderRadius: "5px" }}>

                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th>
                            Max geofence area (in meters) {getSortIcon()}
                          </th>
                          <th>
                            Max available seat {getSortIcon()}
                          </th>
                          <th>
                            Last Order Time - n hour(s) before the departure time. {getSortIcon()}
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr key={'set-max'} style={{ height: "100px" }}>
                          <td>
                            <TextBox
                              className="shuttle_bus_booking_create_item_main_box_field"
                              value={editData.max_geofence_area}
                              type="number"
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  max_geofence_area: e.target.value,
                                })
                              }
                            />
                          </td>
                          <td>
                            <TextBox
                              className="shuttle_bus_booking_create_item_main_box_field"
                              value={editData.max_available_seat}
                              type="number"
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  max_available_seat: e.target.value,
                                })
                              }
                            />
                          </td>
                          <td>
                            <TextBox
                              className="shuttle_bus_booking_create_item_main_box_field"
                              value={editData.max_order_time}
                              type="number"
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  max_order_time: e.target.value,
                                })
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>



                </div>
              )}

              {selected_tab == 1 && (
                <div className="shuttle_bus_booking_create_item_main_box_detail">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Max geofence area  & available seat
                  </div>
                  <div style={{ marginTop: "10px", border: "1px solid #eee", borderRadius: "5px" }}>

                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th>
                            Max geofence area (in meters) {getSortIcon()}
                          </th>
                          <th>
                            Max available seat {getSortIcon()}
                          </th>
                          <th>
                            Last Order Time - n hour(s) before the departure time. {getSortIcon()}
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr key={'set-max'} style={{ height: "100px" }}>
                          <td>{editData.max_geofence_area}</td>
                          <td>{editData.max_available_seat}</td>
                          <td>{editData.max_order_time}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>



                </div>
              )}
            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                {selected_tab !== 0 &&
                  <Button
                    className="footer-previous-btn font-family-poppins"
                    onClick={() => {
                      callback_handleBackBtn();
                    }}
                  >
                    Previous
                  </Button>
                }
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST);
                  }}
                >
                  Cancel
                </Button>
              </div>

              {selected_tab !== 1 &&
                <div className="footer-right">

                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleNext();
                    }}
                  >
                    Next
                    <Icon>
                      <img alt="" src={NextIcon} />
                    </Icon>
                  </Button>
                </div>
              }

              {selected_tab === 1 &&
                <div className="footer-right">
                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleSubmit();
                    }}
                  >
                    Submit
                  </Button>
                </div>
              }

            </div>
          </div>



        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
